import { QueryKeys } from "@app/constants/query-keys.ts";
import { useApis } from "@app/data/apis.ts";
import { ExtensionPostModel } from "@app/data/engine.ts";
import { handleApiError } from "@app/helpers/error-helper.tsx";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "bi-lib";
import { toast } from "react-toastify";

interface Props {
    id?: number;
}

export default function useSetupExtensionsData({ id }: Props = {}) {
    const apis = useApis();
    const queryClient = useQueryClient();

    const getSortedExtensionQuery = useQuery({
        queryKey: [QueryKeys.GetSortedExtension],
        queryFn: () => apis.engine.setupApi.setupApiGetSortedExtensionList(),
    });

    const getExtensionQuery = useQuery({
        queryKey: [QueryKeys.GetExtension, { id }],
        queryFn: () => apis.engine.setupApi.setupApiGetExtensionList({ id }),
        enabled: id != undefined,
    });

    const saveExtensionMutation = useMutation({
        mutationFn: (post: ExtensionPostModel) => apis.engine.setupApi.setupApiSaveExtensionCreate(post),
        onSuccess: (_, { extensionId }) => {
            void queryClient.invalidateQueries({ queryKey: [QueryKeys.GetSortedExtension] });
            void queryClient.invalidateQueries({
                queryKey: [QueryKeys.GetExtension, { id: extensionId }],
            });
            toast.success("Extension saved");
        },
        onError: (error: Error) => handleApiError(error, "Failed to save extension"),
    });

    return {
        extensions: getSortedExtensionQuery,
        extension: getExtensionQuery,

        saveExtension: saveExtensionMutation,
    };
}
